import {
  BuildingOffice2Icon,
  GlobeAltIcon,
  Cog6ToothIcon,
  MapIcon,
  CubeIcon,
} from '@heroicons/react/24/outline';
import type { ComponentType, SVGProps } from 'react';

// A domain pack's `icon` is DATA (`domains.catalog.js` seeds heroicon slugs
// like `building-office`), so the pack tells the UI which glyph it wants and
// the UI decides nothing about which packs exist. Anything unrecognised gets a
// neutral cube rather than nothing — a new pack seeded tomorrow renders a row
// today, just with a generic glyph.
const ICONS: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  'building-office': BuildingOffice2Icon,
  'globe-alt': GlobeAltIcon,
  'cog-6-tooth': Cog6ToothIcon,
  map: MapIcon,
};

export function domainIcon(key: string | null | undefined): ComponentType<SVGProps<SVGSVGElement>> {
  return (key && ICONS[key]) || CubeIcon;
}
